// Configuração de disponibilidade dos gráficos
// Defina como false para ativar um gráfico, true para desativar

export const COLLECTIONS_EVOLUTION_CHART_DISABLED = false;

